var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._g(_vm._b({attrs:{"height":'calc(100vh - ' + _vm.$vuetify.application.top + 'px)',"tile":""}},'v-sheet',_vm.$attrs,false),_vm.$listeners),[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":"","fill-height":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }